/**
 * PostHog Event Registry
 * Single source of truth for all event names.
 * Use these constants everywhere — never hardcode event strings.
 */

export const EVENTS = {
  // Auth
  SIGN_UP: 'sign_up',
  SIGN_IN: 'sign_in',
  SIGN_OUT: 'sign_out',

  // Session
  SESSION_STARTED: 'session_started',
  SESSION_ENDED: 'session_ended',

  // Onboarding
  ONBOARDING_STEP: 'onboarding_step',
  TUTORIAL_STEP: 'tutorial_step',
  FIRST_ACTION: 'first_action_after_onboarding',
  POST_ONBOARDING_JOURNEY: 'post_onboarding_journey',

  // Character
  CHARACTER_CREATION_STARTED: 'character_creation_started',
  CHARACTER_CREATED: 'character_created',
  CHARACTER_ANIMATED: 'character_animated',
  CHARACTER_ENHANCED: 'character_enhanced',
  CHARACTER_EDITED: 'character_edited',

  // Story (video)
  STORY_CREATION_STARTED: 'story_creation_started',
  STORY_CREATED: 'story_created',

  // Storybook (audiobook)
  STORYBOOK_CREATION_STARTED: 'storybook_creation_started',
  STORYBOOK_CREATED: 'storybook_created',
  STORYBOOK_PLAYED: 'storybook_played',
  STORYBOOK_PAGE_TURNED: 'storybook_page_turned',
  STORYBOOK_COMPLETED: 'storybook_completed',

  // Web2app funnel (/funnel-auth) — every step lives at one URL, so each of
  // these is emitted explicitly; see hooks/useFunnelAnalytics.js
  FUNNEL_STARTED: 'funnel_started',
  FUNNEL_STEP_VIEWED: 'funnel_step_viewed',
  FUNNEL_STEP_COMPLETED: 'funnel_step_completed',
  FUNNEL_BACK_CLICKED: 'funnel_back_clicked',
  FUNNEL_PHOTO_ADDED: 'funnel_photo_added',
  FUNNEL_PRESET_FRIEND_SELECTED: 'funnel_preset_friend_selected',
  FUNNEL_GENERATION_STARTED: 'funnel_generation_started',
  FUNNEL_GENERATION_COMPLETED: 'funnel_generation_completed',
  FUNNEL_GENERATION_FAILED: 'funnel_generation_failed',
  FUNNEL_SIGNIN_STARTED: 'funnel_signin_started',
  FUNNEL_SIGNIN_FAILED: 'funnel_signin_failed',
  FUNNEL_EXISTING_ACCOUNT: 'funnel_existing_account',
  // A 'finish setting up' pay-link worth nothing (tampered, expired, already
  // paying, or the backend did not answer): the funnel starts from the top
  FUNNEL_OFFER_INVALID: 'funnel_offer_invalid',
  // A signed-in visitor opened somebody else's pay-link: sent to the home page
  FUNNEL_OFFER_NOT_THEIRS: 'funnel_offer_not_theirs',
  FUNNEL_COMPLETED: 'funnel_completed',
  FUNNEL_COMPLETION_FAILED: 'funnel_completion_failed',
  FUNNEL_INVALID_LINK: 'funnel_invalid_link',
  // In-house paywall + checkout (/funnel-auth)
  FUNNEL_PLAN_SELECTED: 'funnel_plan_selected',
  FUNNEL_BILLING_PERIOD_CHANGED: 'funnel_billing_period_changed',
  // the pay-what-you-want arm of the paywall offer experiment
  FUNNEL_PRICE_CHOOSER_OPENED: 'funnel_price_chooser_opened',
  FUNNEL_PRICE_CHOSEN: 'funnel_price_chosen',
  FUNNEL_CHECKOUT_STARTED: 'funnel_checkout_started',
  FUNNEL_CHECKOUT_FAILED: 'funnel_checkout_failed',
  FUNNEL_PURCHASE_COMPLETED: 'funnel_purchase_completed',
  // Our server read the Checkout Session back from Stripe (verified: bool)
  FUNNEL_PURCHASE_VERIFIED: 'funnel_purchase_verified',
  // The success screen's App Store button
  FUNNEL_APP_DOWNLOAD_CLICKED: 'funnel_app_download_clicked',
  // Tapped the "watch while you wait" episode on the generating step
  FUNNEL_WAIT_VIDEO_PLAYED: 'funnel_wait_video_played',

  // Content
  CONTENT_VIEWED: 'content_viewed',
  CONTENT_SHARED: 'content_shared',
  PAGE_VIEWED: 'page_viewed',

  // Purchases
  SUBSCRIPTION_PURCHASED: 'subscription_purchased',
  STARS_PURCHASED: 'stars_purchased',

  // Errors
  ERROR: 'error',
};
